import { CONTRACT_PENDING_LINKS } from '@loot/shared';
import type { HomeCardsConfig } from '../../components/home-cards.tsx';

/** Cartões da Visão geral: Jurídico (ADR 0097). */
export const LEGAL_CARDS: HomeCardsConfig = {
  queryKey: 'legal',
  endpoint: '/legal/home-cards',
  consultTo: '/legal/pending',
  cards: [
    {
      id: 'contracts_expired',
      section: 'deadline',
      title: 'legal.homeCards.contractsExpired.title',
      criterion: 'legal.homeCards.contractsExpired.criterion',
      unit: 'legal.homeCards.units.contract',
      link: { to: '/legal/contracts', search: { due: 'expired' } },
    },
    {
      id: 'non_renewal_notice',
      upcoming: true,
      section: 'deadline',
      title: 'legal.homeCards.nonRenewal.title',
      criterion: 'legal.homeCards.nonRenewal.criterion',
      unit: 'legal.homeCards.units.contract',
      link: { to: '/legal/contracts', search: { due: 'notice' } },
    },
    {
      id: 'obligations_overdue',
      section: 'deadline',
      title: 'legal.homeCards.obligations.title',
      criterion: 'legal.homeCards.obligations.criterion',
      unit: 'legal.homeCards.units.obligation',
      link: { to: '/legal/agenda', search: { source: 'obligation', light: 'overdue' } },
    },
    {
      id: 'procedural_overdue',
      section: 'deadline',
      title: 'legal.homeCards.procedural.title',
      criterion: 'legal.homeCards.procedural.criterion',
      unit: 'legal.homeCards.units.deadline',
      link: {
        to: '/legal/agenda',
        search: { kind: 'procedural_deadline', origin: 'lawsuit', light: 'overdue' },
      },
    },
    {
      id: 'contract_pending',
      section: 'pending',
      title: 'legal.homeCards.contractPending.title',
      criterion: 'legal.homeCards.contractPending.criterion',
      unit: 'legal.homeCards.units.contract',
      link: { to: '/legal/contracts/reconciliation' },
      detailPrefix: 'legal.contracts.pending',
      detailOrder: [...CONTRACT_PENDING_LINKS],
    },
    {
      id: 'unassigned',
      section: 'pending',
      title: 'legal.homeCards.unassigned.title',
      criterion: 'legal.homeCards.unassigned.criterion',
      unit: 'legal.homeCards.units.request',
      link: { to: '/legal/queue', search: { assignee: 'none' } },
    },
  ],
};
